import request from '../utils/request'
export function detail(data) {
    return request({
        url: '/activity/detail',
        method: 'post',
        data
    })
}
// 是否又红包活动
export function openactivity(data) {
    return request({
        url: '/activity/find/is/open/activity',
        method: 'post',
        data
    })
}

export function getSignature(data) {
    return request({
        url: '/activity/getSignature',
        method: 'post',
        data
    })
}
//活动列表
export function eventList(data) {
    return request({
        url: '/trace/eventList',
        method: 'post',
        data
    })
}
//厂商信息
export function firmInfo(data) {
    return request({
        url: '/trace/firmInfo',
        method: 'post',
        data
    })
}
//用户是否关注公众号
export function isFollow(data) {
    return request({
        url: '/trace/isFollow',
        method: 'post',
        data
    })
}
//溯源信息
export function productInfo(data) {
    return request({
        url: '/trace/productInfo',
        method: 'post',
        data
    })
}
//产品
export function traceInfo(data) {
    return request({
        url: '/trace/traceInfo',
        method: 'post',
        data
    })
}
//活动详情
export function ActivityDetails(data) {
    return request({
        url: '/activity/details',
        method: 'post',
        data
    })
}
//是否关注
export function isAttention(data) {
    return request({
        url: '/activity/isAttention',
        method: 'post',
        data
    })
}
//是否领取
export function isReceive(data) {
    return request({
        url: '/activity/isReceive',
        method: 'post',
        data
    })
}
// 导购员和说源码关联接口
export function salesRecordusePromotions(data) {
    return request({
        url: '/salesRecord/usePromotions',
        method: 'post',
        data
    })
}
// 首页红包展示
export function indexRedpacket(data) {
    return request({
        url: '/activity/indexRedpacket',
        method: 'post',
        data
    })
}
// 分享后进入红包
export function getShareLinks(data) {
    return request({
        url: '/activity/getShareLinks',
        method: 'post',
        data
    })
}
// 个人信息
export function personInfo(data) {
    return request({
        url: '/trace/personInfo',
        method: 'post',
        data
    })
}
// 绑定手机号还是解绑手机号
export function bindAndUnbind(data) {
    return request({
        url: '/trace/bindAndUnbind',
        method: 'post',
        data
    })
}
// 手机验证码
export function sendVerificationCode(data) {
    return request({
        url: '/trace/sendVerificationCode',
        method: 'post',
        data
    })
}
// 企业logo
export function firmLogo(id) {
    return request({
        url: '/trace/find/FirmLogo/' + id,
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js